__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "mattermost-webapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hello-pangea/dnd", "18.0.1", () => (Promise.all([__webpack_require__.e(1190), __webpack_require__.e(9471), __webpack_require__.e(7967), __webpack_require__.e(2140), __webpack_require__.e(4405)]).then(() => (() => (__webpack_require__(71190))))));
			register("@mattermost/client", "12.0.0", () => (Promise.all([__webpack_require__.e(2513), __webpack_require__.e(649)]).then(() => (() => (__webpack_require__(70649))))));
			register("history", "4.10.1", () => (__webpack_require__.e(7291).then(() => (() => (__webpack_require__(7291))))));
			register("luxon", "3.6.1", () => (__webpack_require__.e(8943).then(() => (() => (__webpack_require__(58943))))));
			register("react-bootstrap", "github:mattermost/react-bootstrap#d693ec8082954f0e6d3e826ca6161979b29001cd", () => (Promise.all([__webpack_require__.e(7996), __webpack_require__.e(9214), __webpack_require__.e(9471), __webpack_require__.e(7967), __webpack_require__.e(8735)]).then(() => (() => (__webpack_require__(99214))))));
			register("react-dom", "19.2.8", () => (Promise.all([__webpack_require__.e(9471), __webpack_require__.e(7663)]).then(() => (() => (__webpack_require__(67663))))));
			register("react-intl", "*", () => (Promise.all([__webpack_require__.e(6935), __webpack_require__.e(9471)]).then(() => (() => (__webpack_require__(56935))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(3122), __webpack_require__.e(9471)]).then(() => (() => (__webpack_require__(13122))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(7786), __webpack_require__.e(9471), __webpack_require__.e(2973)]).then(() => (() => (__webpack_require__(57786))))));
			register("react", "19.2.8", () => (__webpack_require__.e(5630).then(() => (() => (__webpack_require__(15630))))));
			register("styled-components", "5.3.7", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(9471), __webpack_require__.e(4040)]).then(() => (() => (__webpack_require__(50961))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};